import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

const Header = ({ siteTitle, site }) => {
  const query = useStaticQuery(graphql`
    query Headers {
      servicio: allStrapiBotonServiciosEnLinea {
        edges {
          node {
            Titulo
            Enlace
            Icono {
              url
            }
            Activo
          }
        }
      }

      supersalud: allStrapiSuperSaluds(sort: { order: ASC, fields: id }) {
        edges {
          node {
            Titulo
            Link
            Activo
          }
        }
      }

      allStrapiMainMenu {
        edges {
          node {
            menu_item {
              title
              site
              page {
                slug
              }
              sub_item {
                title
                page {
                  slug
                  title
                  site
                }
              }
            }
          }
        }
      }
    }
  `)

  const menu = query.allStrapiMainMenu.edges
  const servicios = query.servicio.edges
  const super_salud = query.supersalud.edges
  let url_global = process.env.GATSBY_API_URL

  return (
    <>
      <div className="relative top-8 menu_mode_black" tabIndex="1">
        <header className="container mx-auto">
          <noscript>
            <iframe
              src="https://www.googletagmanager.com/ns.html?id=GTM-K6GJ6JT"
              height="0"
              width="0"
              style={{ display: "none", visibility: "hidden" }}
            ></iframe>
          </noscript>
          <div id="fondo-aviso-cookies" className="fondo-aviso-cookies"></div>

          <nav className="w-full z-30 flex items-center justify-between flex-wrap p-6 ajustar_tamano_text_inicio mitexto_color">
            <div className="buscar buscador_lg" style={{ display: "none" }}>
              <form id="demo-b" className="buscador">
                <input type="search" id="buscadores" />
              </form>
            </div>

            <div className="relative w-2/5 mr-16 iniciar_sesion_nav_header lg:hidden flex items-center flex-shrink-0 text-white mr-6">
              {servicios.map(({ node: servicio_linea }, i) => {
                if (servicio_linea.Activo === true) {
                  return (
                    <a href={servicio_linea.Enlace} key={`m-${i}`}>
                      <button className="w-full background-secundary bg-green-900 text-white h-12  font-bold py-2 px-4 rounded-full inline-flex items-center texto-alineado">
                        <div className="leading-4 text-center flex items-center ml-auto mr-auto">
                          <img
                            className="relative right-4 fill-current w-11 h-11 mr-2"
                            src={url_global + servicio_linea.Icono.url}
                            alt={servicio_linea.Titulo}
                            title={servicio_linea.Titulo}
                          />
                          <span className="relative right-4">
                            {servicio_linea.Titulo}
                          </span>
                        </div>
                      </button>
                    </a>
                  )
                }
              })}
            </div>

            <div
              className="ajustar_tamano_text_inicio w-full flex-grow lg:flex lg:items-center lg:w-auto hidden mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20"
              id="nav-content"
              tabIndex="1"
              style={{ zIndex: "99999999" }}
            >
              <ul className="list-reset lg:flex justify-end flex-1 items-center">
                {/* ESTE ESPACIO ES PARA LOS BOTONES RESTANTES  */}
                <li className="mr-3">
                  <div className="relative inline-block text-left">
                    <div>
                      <button
                        id="menu-button"
                        className="gap-2 color-texto-parrafo text-poppins-regular inline-flex w-full justify-center rounded-md px-4 py-2"
                        aria-expanded="true"
                        aria-haspopup="true"
                      >
                        <svg
                          className="ml-2 h-4 w-4"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" />
                        </svg>
                        Transparencia
                      </button>
                    </div>

                    <div
                      className="absolute hidden menu_super_salud right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="menu-button"
                      tabIndex="-1"
                    >
                      <div className="py-1 color-texto-parrafo" role="none">
                        {super_salud.map(({ node: salud }, i) => {
                          if (salud.Activo === true) {
                            return (
                              <a
                                href={salud.Link}
                                target="_blank"
                                className="color-texto-parrafo text-poppins-regular block px-4 py-2 text-sm"
                                role="menuitem"
                                tabIndex="-1"
                                id={`menu-item-${i}`}
                                key={`n-${i}`}
                              >
                                {salud.Titulo}
                              </a>
                            )
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </li>

                {/* ESTE ESPACIO ES PARA  BOTONES RESTANTES*/}

                <li className="mr-3">
                  <a
                    tabIndex="1"
                    className={
                      "text-poppins-regular perfil_mode_black inline-block no-underline rounded-full py-2 px-4 " +
                      (site === "personas"
                        ? "text-white bg-green-hover font-semibold"
                        : "color-texto-parrafo hover:text-green-700 hover:bg-green-hover")
                    }
                    href={"/personas"}
                  >
                    Personas
                  </a>
                </li>
                <li className="mr-3">
                  <a
                    tabIndex="1"
                    className={
                      "text-poppins-regular perfil_mode_black inline-block no-underline rounded-full py-2 px-4 " +
                      (site === "empresas"
                        ? "text-white fondo_rol_empresas font-semibold"
                        : "color-texto-parrafo hover:text-green-900 hover:bg-green-hover")
                    }
                    href={"/empresas"}
                  >
                    Empresas
                  </a>
                </li>
                <li className="mr-3">
                  <a
                    tabIndex="1"
                    className={
                      "text-poppins-regular perfil_mode_black inline-block no-underline rounded-full py-2 px-4 " +
                      (site === "proveedores"
                        ? "text-white text-poppins-bold fondo_rol_proveedor font-semibold"
                        : "color-texto-parrafo hover:text-green-700 hover:bg-green-hover")
                    }
                    href={"/proveedores"}
                  >
                    Proveedores
                  </a>
                </li>
                <li className="mr-3">
                  <div className="buscar">
                    <form id="demo-b" className="buscador">
                      <input tabIndex="1" type="search" id="buscador" />
                    </form>
                  </div>
                </li>
                {servicios.map(({ node: servicio_linea }, i) => {
                  if (servicio_linea.Activo === true) {
                    return (
                      <li
                        style={{ top: "0.3rem", width: "8rem" }}
                        className="relative mr-3 ancho_boton_servicio_linea"
                        key={`ser-${i}`}
                      >
                        <a tabIndex="1" href={servicio_linea.Enlace}>
                          <button className="w-full background-secundary bg-green-900 text-white h-12 font-bold py-2 px-4 rounded-full inline-flex items-center altura_boton_sesion">
                            <div className="leading-4 text-center flex items-center ml-auto mr-auto">
                              <img
                                className="relative right-4 fill-current w-11 h-11 mr-2 tamano_icono_servicio"
                                src={url_global + servicio_linea.Icono.url}
                                alt={servicio_linea.Titulo}
                                title={servicio_linea.Titulo}
                              />
                              <span className="relative right-4 linear_logo_servicio_linea">
                                {servicio_linea.Titulo}
                              </span>
                            </div>
                          </button>
                        </a>
                      </li>
                    )
                  }
                })}
              </ul>
            </div>
          </nav>

          <nav
            style={{ marginTop: "0.5rem", zIndex: "9" }}
            className="relative alinear_menu_dos text-poppins-bold-dos  lg:relative -top-5 z-30 flex items-center justify-end flex-wrap"
          >
            <div
              style={{ marginTop: "-6.7rem" }}
              className="relative boton_desplegable block lg:hidden pr-4"
            >
              <button
                id="nav-toggles"
                className="rounded-full h-11 w-11 justify-center border rounded flex items-center p-1 bg-green-900 text-white hover:text-white-900 focus:outline-none focus:shadow-outline transform transition hover:scale-105 duration-300 ease-in-out"
              >
                <svg
                  className="fill-current h-6 w-6"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                </svg>
              </button>

              {/*---------------------------------- Etiquetas para movil menu desplegable  -------------------------------------- */}

              <ul
                id="menu_show"
                className="absolute hidden text-gray-700 pt-1"
                style={{
                  right: "0rem",
                  textAlign: "right",
                  width: "13rem",
                }}
              >
                <li className="">
                  {site === "proveedores" && (
                    <div className="mitexto header_icono_home_desplegable">
                      <a
                        className="text-poppins-regular flex items-center font-bold"
                        href={"/" + site}
                      >
                        <img
                          src={url_global + "/uploads/logo_a1b429d0e0.PNG"}
                          className="alineacion_imagen_home_desplegable"
                          alt="Logo EPSdelagente"
                          title="Logo EPSdelagente"
                          quality={95}
                          formats={["AUTO", "WEBP", "AVIF"]}
                          style={{ width: "400px", zIndex: "99999" }}
                        />
                      </a>
                    </div>
                  )}
                </li>
                <li className="">
                  {site === "empresas" && (
                    <div className="mitexto header_icono_home_desplegable">
                      <a
                        className="text-poppins-regular flex items-center font-bold"
                        href={"/" + site}
                      >
                        <img
                          src={url_global + "/uploads/logo_a1b429d0e0.PNG"}
                          className="alineacion_imagen_home_desplegable"
                          alt="Logo EPSdelagente"
                          title="Logo EPSdelagente"
                          quality={95}
                          formats={["AUTO", "WEBP", "AVIF"]}
                          style={{ width: "400px", zIndex: "99999" }}
                        />
                      </a>
                    </div>
                  )}
                </li>
                <li className="">
                  {site === "personas" && (
                    <div className="mitexto header_icono_home_desplegable">
                      <a
                        className="text-poppins-regular flex items-center font-bold"
                        href={"/" + site}
                      >
                        <img
                          src={url_global + "/uploads/logo_a1b429d0e0.PNG"}
                          className="alineacion_imagen_home_desplegable"
                          alt="Logo EPSdelagente"
                          title="Logo EPSdelagente"
                          quality={95}
                          formats={["AUTO", "WEBP", "AVIF"]}
                          style={{ width: "400px", zIndex: "99999" }}
                        />
                      </a>
                    </div>
                  )}
                </li>

                <div className="block mitexto nav_header_perfilador lg:hidden pr-4">
                  <div
                    className=""
                    style={{
                      zIndex: "78",
                      position: "relative",
                      paddingLeft: "0rem",
                    }}
                  >
                    <div className="dropdown inline-block relative">
                      <button
                        id="opcion"
                        className="rounded-full text-green-300 bg-gray-500 font-semibold py-3 px-4 inline-flex items-center"
                        style={{
                          color: "#c5cc0c",
                          position: "relative",
                          left: "1rem",
                        }}
                      >
                        <span
                          id="sitios"
                          className="mr-1"
                          style={{ fontSize: "11px" }}
                        >
                          {site}
                        </span>

                        <svg
                          className="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                          style={{ color: "white !important" }}
                        >
                          <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>{" "}
                        </svg>
                      </button>

                      <ul
                        id="menu_hide"
                        className="relative hidden font-semibold text-poppins-regular text-gray-700 pt-1"
                      >
                        <div className="grid">
                          <li className="inline-flex items-center">
                            <img
                              className="relative icono_boton_flotante_rueda"
                              src={
                                process.env.GATSBY_API_URL +
                                "/uploads/personas_gris_2ff7231d49.png"
                              }
                              formats={["auto", "webp", "avif"]}
                              width={35}
                              height={35}
                              alt="Boton aqui te ayudamos"
                              title="Boton aqui te ayudamos"
                            />

                            <a
                              className="mitexto_color rounded-t color-texto-parrafo hover:bg-gray-300 py-2 px-4 block whitespace-no-wrap"
                              href="/personas"
                            >
                              <p id="personas">Personas</p>
                            </a>
                          </li>
                          <li className="inline-flex items-center">
                            <img
                              className="relative icono_boton_flotante_rueda"
                              src={
                                process.env.GATSBY_API_URL +
                                "/uploads/empresas_gris_3205017874.png"
                              }
                              formats={["auto", "webp", "avif"]}
                              width={35}
                              height={35}
                              title="Boton aqui te ayudamos"
                              alt="Boton aqui te ayudamos"
                            />
                            <a
                              id="Empresas"
                              className="mitexto_color color-texto-parrafo hover:bg-gray-300 py-2 px-4 block whitespace-no-wrap"
                              href="/empresas"
                            >
                              <p id="empresas">Empresas</p>
                            </a>
                          </li>
                          <li className="inline-flex items-center">
                            <img
                              className="relative icono_boton_flotante_rueda"
                              src={
                                process.env.GATSBY_API_URL +
                                "/uploads/proveedores_gris_ff5f417eba.png"
                              }
                              formats={["auto", "webp", "avif"]}
                              width={35}
                              height={35}
                              alt="Boton aqui te ayudamos"
                              title="Boton aqui te ayudamos"
                            />
                            <a
                              id="Proveedores"
                              className="mitexto_color rounded-b color-texto-parrafo hover:bg-gray-300 py-2 px-4 block whitespace-no-wrap"
                              href="/proveedores"
                            >
                              <p id="proveedores">Proveedores</p>
                            </a>
                          </li>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* </li> */}

                {/*INICIO BOTONES SUPER SALUD MOVIL*/}
                <li className="">
                  <div className="relative inline-block text-left">
                    <div>
                      <button
                        id="menu-button-movil"
                        className="mt-2 gap-2 mitexto mitexto_color color-texto-parrafo text-poppins-regular inline-flex w-full rounded-md pl-2 py-2"
                        aria-expanded="true"
                        aria-haspopup="true"
                      >
                        <svg
                          className="-mr-1 ml-2 h-4 w-4"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <path d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" />
                        </svg>
                        Transparencia
                      </button>
                    </div>

                    <div
                      className="relative hidden menu_super_salud right-0 z-10 w-56 origin-top-right rounded-md bg-white"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="menu-button"
                      tabIndex="-1"
                    >
                      <div
                        className="py-1 color-texto-parrafo text-poppins-regular"
                        role="none"
                      >
                        {super_salud.map(({ node: salud }, i) => {
                          if (salud.Activo === true) {
                            return (
                              <a
                                href={salud.Link}
                                target="_blank"
                                className="color-texto-parrafo text-poppins-regular block px-4 py-2 text-sm"
                                role="menuitem"
                                tabIndex="-1"
                                id={`menu-item-${i}`}
                                key={`n-${i}`}
                              >
                                {salud.Titulo}
                              </a>
                            )
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </li>

                {/*FINAL BOTONES SUPER SALUD MOVIL*/}

                <li className="">
                  <a
                    className="mitexto mitexto_color estilo_menu_principal text-poppins-regular inline-block no-underline color-texto-parrafo text-poppins-regular text-poppins-bold-dos rounded-full  hover:text-white hover:bg-green-900  hover:text-black py-2 px-4"
                    href={"/" + site}
                  >
                    Inicio
                  </a>
                </li>

                <Item_dos item={menu[0]} key={0} site={site} />
              </ul>

              {/*------------------------------------Fin de las etiquetas movil menu desplegable----------------------------------  */}
            </div>

            {/* </nav>

           <nav>  */}

            <div className="contenedor_dark_mode_header">
              <div
                className="alinear_segundo_menu_inicio w-full flex-grow lg:flex lg:items-center lg:w-auto hidden mt-2 lg:mt-0 bg-white lg:bg-transparent text-black p-4 lg:p-0 z-20"
                id="nav-content"
                tabIndex="1"
              >
                <ul className="list-reset lg:flex justify-end flex-1 items-center ">
                  <li className="mr-3">
                    <a
                      className="mitexto_color menu_two_mode_black text-poppins-regular inline-block no-underline color-texto-parrafo text-poppins-regular text-poppins-bold-dos rounded-full  hover:text-white hover:bg-green-900  hover:text-black py-2 px-4"
                      href={"/" + site}
                    >
                      Inicio
                    </a>
                  </li>

                  <Item item={menu[0]} key={0} site={site} />
                </ul>
              </div>
            </div>
          </nav>

          {/* ¨PERFIL DE PROVEEDORES */}

          {/* FIN DE PERFIL DE PROVEEDORES */}
          {/* </a> */}
          {/* Final del Menu para pantalllas mas grandes que md, lg  */}

          {site === "proveedores" && (
            <div
              tabIndex="1"
              className="header_icono_ventaja lg:titulo_ajustado_ventaja_banner -mt-24 pl-28"
            >
              <a
                className="text-poppins-regular flex items-center font-bold"
                href={"/" + site}
              >
                <img
                  src={url_global + "/uploads/logo_a1b429d0e0.PNG"}
                  className="right-20 alineacion_imagen_inicio"
                  quality={95}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  alt="Logo EPSdelagente"
                  title="Logo EPSdelagente"
                  style={{
                    width: "400px",
                    zIndex: "99999",
                    position: "relative",
                    left: "0rem",
                  }}
                />
              </a>
            </div>
          )}

          {site === "proveedores" && (
            <div className="hidden header_icono_ventaja_blanco lg:titulo_ajustado_ventaja_banner -mt-24 pl-28">
              <a
                className="text-poppins-regular flex items-center font-bold"
                href={"/" + site}
              >
                <img
                  src={
                    url_global +
                    "/uploads/logo_epsdelagente_2022_blanco_8c1a4a23da.png"
                  }
                  className="right-20 alineacion_imagen_inicio"
                  alt="Logo EPSdelagente"
                  title="Logo EPSdelagente"
                  quality={95}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  style={{
                    width: "400px",
                    zIndex: "99999",
                    position: "relative",
                    left: "0rem",
                  }}
                />
              </a>
            </div>
          )}

          {site === "empresas" && (
            <div
              tabIndex="1"
              className="header_icono_ventaja lg:titulo_ajustado_ventaja_banner -mt-24 pl-8"
            >
              <a
                className="text-poppins-regular flex items-center font-bold"
                href={"/" + site}
              >
                <img
                  src={url_global + "/uploads/logo_a1b429d0e0.PNG"}
                  className="right-20 alineacion_imagen_inicio"
                  alt="Logo EPSdelagente"
                  title="Logo EPSdelagente"
                  quality={95}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  style={{ width: "400px", zIndex: "99999" }}
                />
              </a>
            </div>
          )}

          {site === "empresas" && (
            <div className="hidden header_icono_ventaja_blanco lg:titulo_ajustado_ventaja_banner -mt-24 pl-8">
              <a
                className="text-poppins-regular flex items-center font-bold"
                href={"/" + site}
              >
                <img
                  src={
                    url_global +
                    "/uploads/logo_epsdelagente_2022_blanco_8c1a4a23da.png"
                  }
                  className="right-20 alineacion_imagen_inicio"
                  alt="Logo EPSdelagente"
                  title="Logo EPSdelagente"
                  quality={95}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  style={{ width: "400px", zIndex: "99999" }}
                />
              </a>
            </div>
          )}

          {site === "personas" && (
            <div
              tabIndex="1"
              className="header_icono_ventaja lg:titulo_ajustado_ventaja_banner -mt-24 pl-8"
            >
              <a
                className="text-poppins-regular flex items-center font-bold"
                href={"/" + site}
              >
                <img
                  src={url_global + "/uploads/logo_a1b429d0e0.PNG"}
                  className="alineacion_imagen_inicio"
                  alt="Logo EPSdelagente"
                  title="Logo EPSdelagente"
                  quality={95}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  style={{ width: "400px", zIndex: "99999" }}
                />
              </a>
            </div>
          )}

          {site === "personas" && (
            <div className="hidden header_icono_ventaja_blanco lg:titulo_ajustado_ventaja_banner -mt-24 pl-8">
              <a
                className="text-poppins-regular flex items-center font-bold"
                href={"/" + site}
              >
                <img
                  src={
                    url_global +
                    "/uploads/logo_epsdelagente_2022_blanco_8c1a4a23da.png"
                  }
                  className="alineacion_imagen_inicio_blanco"
                  alt="Logo EPSdelagente"
                  title="Logo EPSdelagente"
                  quality={95}
                  formats={["AUTO", "WEBP", "AVIF"]}
                  style={{ width: "400px", zIndex: "99999" }}
                />
              </a>
            </div>
          )}

          <div
            id="aviso-cookies"
            className="fixed ubicar_banner_cookie aviso-cookies bottom-0 text-center left-0 lg:fixed pb-20 ubicar_banner_cookie w-full bg-footer border-t border-gray-400"
          >
            <div className="relative alinaecion_texto_aceptacion_index top-8 ml-96 items-center flex flex-wrap container inline-grid grid-cols-2 gap-4 justify-center w-full">
              <div className="text-left mr-8 ml-0 alineacion_politica_texto">
                <p className="tamano_letra_cookies text-white text-poppins-regular">
                  Para mejorar tu experiencia, utilizamos cookies.
                </p>
                <p className="tamano_letra_cookie text-white text-poppins-regular">
                  Da clic en "Aceptar" si estas de acuerdo con las politicas.
                  <strong>
                    <a href="#" className="underline">
                      Más info.
                    </a>
                  </strong>
                </p>
              </div>
              <div className="col-span relative flex-wrap w-52 banner_cookies_movil_inicio">
                <div>
                  <div className="posicion_aceptacion_index space-x-5 ubicacion_aceptacion_cookies tamano_texto_aceptar_cookies md:flex text-base text-white">
                    <p className="separacion_aceptacion_cookies">
                      <a
                        id="btn-aceptar-cookies"
                        className="cursor-pointer inline-block no-underline rounded-full bg-green-hover py-1 px-2 font-semibold"
                      >
                        Aceptar
                      </a>
                    </p>
                    <p className="alineacion_no_gracias">
                      <a
                        id="btn-no-cookies"
                        className="cursor-pointer inline-block no-underline rounded-full hover:text-green-600 hover:bg-white py-1 px-2"
                      >
                        No, gracias
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
    </>
  )
}

function Item(payload) {
  if (!payload || !payload.item.node || !payload.item.node.menu_item)
    return <></>

  const listItems = payload.item.node?.menu_item
    .filter(f => f.site === payload.site)
    .map((node, i) => {
      if (node.site != undefined && node?.page?.slug != null) {
        return (
          <li
            tabIndex="1"
            className="relative mitexto estilo_menu_principal parent text-poppins-bold-dos"
            key={`n-${i}`}
          >
            <a
              href={"/" + node.site + "/" + node?.page?.slug}
              className="flex mitexto_color menu_two_mode_black sin_espacios justify-between color-texto-parrafo text-poppins-regular text-poppins-bold-dos md:inline-flex py-2 px-4 items-center rounded-full  hover:text-white hover:bg-green-900  space-x-2"
            >
              <span className="text-poppins-bold-dos">{node.title}</span>
            </a>
            <SubItem node={node} />
          </li>
        )
      }
      if (node.site != undefined || node?.page?.slug === null) {
        return (
          <li
            tabIndex="1"
            className="relative mitexto menu_principal estilo_menu_principal parent text-poppins-bold-dos color-texto-parrafo"
            key={`n-${i}`}
          >
            <a
              href={"#"}
              className="flex mitexto_color menu_two_mode_black sin_espacios justify-between color-texto-parrafo text-poppins-regular text-poppins-bold-dos md:inline-flex py-2 px-4 items-center rounded-full hover:text-white hover:bg-green-900  space-x-2"
            >
              <svg
                className="icono fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                style={{ color: "gray", display: "block" }}
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>{" "}
              </svg>
              <span className="text-poppins-bold-dos">{node.title}</span>
            </a>
            <SubItem node={node} />
          </li>
        )
      }
    })

  return listItems
}

function SubItem(payload) {
  if (!payload.node || !payload.node.sub_item) return <></>

  const listItems = payload.node?.sub_item.map((submenu, i) => (
    <li tabIndex="1" className="mr-3" key={`s-${i}`}>
      <a
        className="text-poppins-regular flex px-4 py-2 hover:bg-gray-200"
        href={"/" + submenu?.page?.site + "/" + submenu?.page?.slug}
      >
        {submenu?.title}
      </a>
    </li>
  ))

  return (
    <ul
      tabIndex="1"
      className="w-full sub_items child hidden transition duration-300 md:absolute top-full right-0 md:w-80 bg-white md:shadow-lg md:rounded-b z-30"
    >
      {listItems}
    </ul>
  )
}

/////////////////////////////////////////////////////////////////// PARA MOVILES DESPLEGABLE /////////////////////////////////////////////////////////////////////////////////////////

function Item_dos(payload) {
  if (!payload || !payload.item.node || !payload.item.node.menu_item)
    return <></>

  const listItems = payload.item.node?.menu_item
    .filter(f => f.site === payload.site)
    .map((node, i) => {
      if (node.site != undefined && node?.page?.slug != null) {
        return (
          <li
            className="relative mitexto estilo_menu_principal parent text-poppins-bold-dos"
            key={`n-${i}`}
          >
            <a
              href={"/" + node.site + "/" + node?.page?.slug}
              className="flex mitexto mitexto_color sin_espacios_dos justify-start color-texto-parrafo text-poppins-regular text-poppins-bold-dos md:inline-flex py-2 px-4 items-center rounded-full  hover:text-white hover:bg-green-900  space-x-2"
            >
              <span className="text-poppins-bold-dos">{node.title}</span>
            </a>
            <SubItem_dos node={node} />
          </li>
        )
      }
      if (node.site != undefined || node?.page?.slug === null) {
        return (
          <li
            className="relative mitexto menu_principal estilo_menu_principal parent text-poppins-bold-dos color-texto-parrafo"
            key={`n-${i}`}
          >
            <a
              href={"#"}
              className="flex mitexto mitexto_color sin_espacios_dos justify-start color-texto-parrafo text-poppins-regular text-poppins-bold-dos md:inline-flex py-2 px-4 items-center rounded-full hover:text-white hover:bg-green-900  space-x-2"
            >
              <svg
                className="icono fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                style={{ color: "gray", display: "block" }}
              >
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>{" "}
              </svg>
              <span className="text-poppins-bold-dos">{node.title}</span>
            </a>
            <SubItem_dos node={node} />
          </li>
        )
      }
    })

  return listItems
}

function SubItem_dos(payload) {
  if (!payload.node || !payload.node.sub_item) return <></>

  const listItems = payload.node?.sub_item.map((submenu, i) => (
    <li className="mr-3 mitexto_color" key={`s-${i}`}>
      <a
        className="text-poppins-regular flex px-4 py-2 hover:bg-gray-200"
        href={"/" + submenu?.page?.site + "/" + submenu?.page?.slug}
      >
        {submenu?.title}
      </a>
    </li>
  ))

  return (
    <ul className="mitexto w-full sub_items child hidden transition duration-300 md:absolute top-full right-0 md:w-80 bg-white md:shadow-lg md:rounded-b z-30">
      {listItems}
    </ul>
  )
}
/////////////////////////////////////////////////////////////////// PARA MOVILES DESPLEGABLE /////////////////////////////////////////////////////////////////////////////////////////

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
